module.exports = "<ul gw-partial=\"Item\"></ul>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/layouts/Menu/menu.html
// module id = 580
// module chunks = 0